import { useCallback } from 'react'
import { useSelector } from 'react-redux'

import { useCrudSelection, resetCrudSelection, useEditingStateWithCtx } from '@/atoms'
import { fitMapToSelection } from '@/map'
import { selectVehiclesListStructure } from '@/features/domain/lists'

export function useTitle() {
  const listStructure = useSelector(selectVehiclesListStructure)
  const { editing } = useEditingStateWithCtx('vehicle')

  const [selection, select] = useCrudSelection('unifiedVehicles')

  const onSelectAll = useCallback(() => {
    const allSelected = listStructure.shownItems <= selection.length

    if (allSelected) {
      resetCrudSelection('unifiedVehicles')
    } else {
      select(
        listStructure.list.reduce<string[]>((acc, item) => {
          if (typeof item === 'string') {
            acc.push(item)
          }
          return acc
        }, []),
      )

      fitMapToSelection({ preventIfVisible: true }, 'add')
    }
  }, [select, selection, listStructure])

  return {
    editing,
    selection,
    onSelectAll,
    listStructure,
    noEntries: listStructure.totalItems === 0,
  }
}
